import React from 'react';
import Column from '../Column';
import { BoardContainer } from './styles';

const Board = ({ columns, onCardClick, onCardMove, onTitleClick }) => {

  const handleDrop = (e, targetColumnId) => {
    const cardId = e.dataTransfer.getData('text');
    const sourceColumnId = e.dataTransfer.getData('sourceColumnId');
    if (sourceColumnId === targetColumnId) return;

    const sourceColumn = columns.find(col => col.id === sourceColumnId);
    const targetColumn = columns.find(col => col.id === targetColumnId);
    const card = sourceColumn.cards.find(c => c.id === cardId);

    const updatedSourceCards = sourceColumn.cards.filter(c => c.id !== cardId);
    const updatedTargetCards = [...targetColumn.cards, card];

    const updatedColumns = columns.map(col => {
      if (col.id === sourceColumnId) {
        return { ...col, cards: updatedSourceCards };
      } else if (col.id === targetColumnId) {
        return { ...col, cards: updatedTargetCards };
      } else {
        return col;
      }
    });

    onCardMove(updatedColumns);
  };

  return (
    <BoardContainer>
      {columns.map(column => (
        <Column
          key={column.id}
          column={column}
          onCardClick={onCardClick}
          onDropCard={handleDrop}
          onTitleClick={onTitleClick}
        />
      ))}
    </BoardContainer>
  );
};

export default Board;
